/* globals PropTypes */

import { Nav, Tab } from 'react-bootstrap'

export default class LocalizedInputs extends React.Component {
  constructor({ settings }) {
    super()
    this.locales = window.gon.application.available_locales
    this.state = {
      activeLocale: I18n._locale
    }
  }

  render () {
    const { activeLocale } = this.state
    return (
      <div className={`localized_inputs_grouped locales-${this.locales.length}`}>
        <Tab.Container activeKey={activeLocale} onSelect={this.handleLocaleSelect.bind(this)}>
          <>
            <Nav variant='tabs'>
              {this.locales.map((locale) =>
                <Nav.Item
                  key={`${locale}-tab-link`}
                >
                  <Nav.Link eventKey={locale}>
                    {locale}
                  </Nav.Link>
                </Nav.Item>)}
            </Nav>
            <Tab.Content>
              {this.locales.map((locale) =>
                <Tab.Pane key={locale} eventKey={locale}>
                  {this.renderChildren(locale)}
                </Tab.Pane>)}
            </Tab.Content>
          </>
        </Tab.Container>
      </div>
    )
  }

  handleLocaleSelect (locale) {
    if (locale) {
      this.setState({ activeLocale: locale })
    }
  }

  renderChildren (locale) {
    const { children, onChangeLocalized } = this.props
    if (_.isArray(children)) {
      return children.map(child => {
        return (
          <LocalizedInput
            {...child}
            key={`${child.props.name}-${locale}`}
            locale={locale}
            onChange={onChangeLocalized}
          />
        )
      })
    } else {
      return (
        <LocalizedInput
          {...children}
          locale={locale}
          onChange={onChangeLocalized}
        />
      )
    }
  }
}

function LocalizedInput (input) {
  const { locale, props, onChange } = input
  const { type, name, localizedValues, label, disabled } = props
  const localizedName = `${props.name}_${locale}`
  return (
    <div className='form-group'>
      {label && <label className='control-label' htmlFor={localizedName}>{label} [{locale.toUpperCase()}]</label>}
      <input.type
        className='form-control'
        locale={locale}
        type={type}
        disabled={disabled}
        onChange={(e) => onChange({ [locale]: e.target.value }, name)}
        defaultValue={localizedValues[locale]}
        name={localizedName}
      />
    </div>
  )
}

LocalizedInputs.propTypes = {
  onChangeLocalized: PropTypes.func,
  children: PropTypes.node.isRequired
}

LocalizedInput.propTypes = {
  locale: PropTypes.string.isRequired,
  name: PropTypes.string,
  label: PropTypes.string,
  localizedValues: PropTypes.object,
  props: PropTypes.object,
  onChange: PropTypes.func
}
